import CopyMailIcon from 'Components/common/assets/svgIcons/CopyMailIcon';
import DeleteIconGilroy from 'Components/common/assets/svgIcons/DeleteIconGilroy';
import Edit from 'Components/common/assets/svgIcons/Edit';
import ThumbsDownIcon from 'Components/common/assets/svgIcons/ThumbsDownIcon';
import ThumbsUpIcon from 'Components/common/assets/svgIcons/ThumbsUpIcon';
import IconTooltipGlobal from 'Components/common/components/IconTooltipGlobal';
import { Divider } from 'antd';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { actions as helperActions } from 'Slice/HelperSlice';
import { selectChatLoading } from 'Selector/ChatBotV2Selector';
import { maxTablet } from 'Utils/utilsStyle';
import { getCurrentTime, valueToObject } from 'Utils/UtilityFunctions';

const Wrapper = styled.div`
display: flex;
flex-direction: column;
justify-content: center;
align-items: center;
.icon-tooltip-global {
  height: 16px;
  svg {
    height: 16px;
    width: 16px;
    cursor: pointer;
    @media all and (max-width: ${maxTablet}) {
      height: 12px;
      width: 12px;
    }
  }
}
.ant-divider-horizontal {
  margin: 10px 0;
  border-color: #bec6c9;
  border-width: 2px;
  @media all and (max-width: ${maxTablet}) {
    margin: 5px 0;
  }
}
`;
type Props = {
  chatResponse: string,
  hideFeedbackIcon: boolean,
  editToggle: () => void,
  deleteToggle: () => void,
  feedbackToggle: (a: boolean) => void,
};

const OutputActionsDiv = function OutputActionsDiv(props: Props) {
  const {
    chatResponse, editToggle, deleteToggle, feedbackToggle, hideFeedbackIcon,
  } = props;
  const dispatch = useDispatch();
  const chatLoading = useSelector(selectChatLoading);
  const startTime = getCurrentTime();
  const host = window.location.href;

  const handleCopy = async (chatData: string) => {
    const chatWithoutHtml = chatData.replace(/<br\s*\/?>/g, '\n').replace(/<\/?b>/g, '').replace(/<span\b[^>]*>(.*?)<\/span>/gi, (match, capturedText: string) => capturedText);
    await navigator.clipboard.writeText(chatWithoutHtml);
    dispatch(helperActions.setNotification({
      message: 'Text Copied!',
      proTip: false,
      rightPlacement: false,
      groupId: 0,
      classnameFlag: true,
      getContainerEle: 'chatContainer',
    }));
    dispatch(helperActions.callFlurryEvent(
      valueToObject('xcgpt_copyResponse_clicked', startTime, {
        host,
      }),
    ));
  };

  return (
    <Wrapper className="output-actions-div">
      <IconTooltipGlobal
        tooltipPlacement="left"
        tooltipTitle="Edit"
        icon={<Edit fllColor="#667982" onClick={editToggle} />}
        disableBtn={chatLoading}
        outputAction
      />
      <Divider type="horizontal" />
      <IconTooltipGlobal
        tooltipPlacement="left"
        tooltipTitle="Copy"
        icon={<CopyMailIcon onClick={() => handleCopy(chatResponse)} />}
        outputAction
      />
      <Divider type="horizontal" />
      <IconTooltipGlobal
        tooltipPlacement="left"
        tooltipTitle="Delete"
        icon={<DeleteIconGilroy onClick={deleteToggle} />}
        outputAction
      />
      {hideFeedbackIcon !== true ? (
        <>
          <Divider type="horizontal" />
          <IconTooltipGlobal
            tooltipPlacement="left"
            tooltipTitle="Thumbs up"
            icon={<ThumbsUpIcon onClickAction={() => feedbackToggle(true)} />}
            outputAction
          />
          <Divider type="horizontal" />
          <IconTooltipGlobal
            tooltipPlacement="left"
            tooltipTitle="Thumbs Down"
            icon={<ThumbsDownIcon onClickAction={() => feedbackToggle(false)} />}
            outputAction
          />
        </>
      )
        : null}
    </Wrapper>
  );
};

export default OutputActionsDiv;
